// extracted by mini-css-extract-plugin
export var label = "_41-1";
export var reminder = "_41-0";